import { useState } from 'react';

import type { Project } from '../api/client';
import { keycloak, logout } from '../keycloak';
import { EditorView } from './EditorView';
import { ProjectsView } from './ProjectsView';

export function App(): React.ReactElement {
  const [project, setProject] = useState<Project | null>(null);

  return (
    <div className="app">
      <nav className="app-nav">
        <span className="brand">Floor plan editor</span>
        <span className="toolbar-gap" />
        <span className="muted small">
          {keycloak.tokenParsed?.preferred_username ?? keycloak.tokenParsed?.sub ?? ''}
        </span>
        <button className="ghost" onClick={logout}>
          Sign out
        </button>
      </nav>

      {project ? (
        <EditorView
          project={project}
          onBack={() => setProject(null)}
          onProjectChanged={setProject}
        />
      ) : (
        <ProjectsView onOpen={setProject} />
      )}
    </div>
  );
}
